import { useProductAPI } from "../../../api/product/useProductAPI";
import { productOutActions } from "./ProductOutReducer";


export const useProductOut= () => {
    const api = useProductAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.productOut.get(params);
              dispatch(productOutActions.funGetProductOut(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.productOut.post(data);
        },
        put: async (data) => {
          return await api.productOut.put(data);
        },
        delete: async (params) => {
          return await api.productOut.delete(params);
        }
    };
    return { request };
  };